export const gameId = 'tictactoe';

// Languages specific to this game
export const languages = [
    { short: "en", full: "English" },
    { short: "ru", full: "русский" },
]

export const gameName = {
    en: 'Tic Tac Toe',
    ru: 'Крестики-нолики',
}

export const uiStrings = {
    /*
    'game_name':
    {
        en: 'Tic Tac Toe',
        ru: 'Крестики-нолики',
    },
    */
    'start_game': 
    {   
        en: 'Start the game',
        ru: 'Начать игру',
    },
    'restart_game': 
    {   
        en: 'Restart the game',
        ru: 'Начать игру заново',
    },        
    'start_new_game': 
    {   
        en: 'Start a new game',
        ru: 'Начать новую игру',
    },    
    'stop_game': 
    {   
        en: 'Stop the game',
        ru: 'Остановить игру',
    },
    'lets_play':
    {
        en: "Let's play!",
        ru: 'Ну что, сыграем?',
    },    
    'who_plays_first':
    {
        en: "Who makes the first move?",
        ru: 'Кто сделает первый ход?',
    },
    'user_begins':
    {   
        en: 'Me',
        ru: 'Я',        
    },
    'opponent_begins':
    {
        en: 'My opponent',
        ru: 'Противник',
    },
    'game_on':
    {
        en: 'The game is on!',
        ru: 'Игра началась!',
    },
    'user_move':
    {
        en: 'Make your move!',
        ru: 'Делайте ход!',
    },    
    'opponent_move':
    {
        en: "Wait for the opponent's move...",
        ru: 'Подождите, пока противник сделает ход...',
    },       
    'user_won':
    {
        en: "Congratulations, you've won!",
        ru: "Поздравляю, вы победили!",
    },
    'opponent_won':
    {
        en: "Your opponent won this time!",
        ru: "На этот раз победил противник!",
    },    
    'score_draw':
    {
        en: "Nobody won this time.",
        ru: "Вы сыграли вничью.",
    },
    


};

